module.exports = __webpack_public_path__ + "static/img/gz_code.78c3cd02.jpg";